<script>
import DeviceDashboardCard from "@/Widgets/Cards/DeviceDashboardCard.vue";

export default {
  name: "DevicesByDeviceType",
  components: {DeviceDashboardCard},
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  data() {
    return {
      chartData: [],
      chartOptions: [],
    }
  },
  methods: {
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);
      return {
        labels: this.data.map((i) => i.device_type.name),
        datasets: [
          {
            label: this.$t('common.devices'),
            data: this.data.map((i) => i.total),
            hoverOffset: 4,
          },
        ]
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      return {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          }
        }
      };
    }
  },
  watch: {
    data: {
      handler: function (newValue, oldValue) {
        this.chartData = this.setChartData();
      },
      immediate: true
    }
  },
  mounted() {
    this.chartOptions = this.setChartOptions();
  }
}
</script>

<template>
  <DeviceDashboardCard
      :title="$t('widgets.charts.devices_by_device_type.total_devices')"
      :subtitle="$t('widgets.charts.devices_by_device_type.by_device_type')"
      :loading="loading"
  >
    <Chart type="doughnut" :data="chartData" :options="chartOptions"/>
  </DeviceDashboardCard>
</template>

<style scoped>

</style>
